module.exports = __webpack_public_path__ + "static/subset-UniNeueHeavy-Italic-b12d847f8e332fe79d0fc40a73c8a7e3.woff2";